import { Component, Input, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-address-field-append',
  templateUrl: './address-field-append.component.html',
  imports: [
    ReactiveFormsModule
  ],
  styleUrls: ['../../address-action.component.scss']
})
export class AddressFieldAppendComponent implements OnInit {
  @Input() fieldControl: FormControl;

  constructor() { }

  ngOnInit(): void {
  }

}
